// typescript
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { IdSessionContext } from "./App";
import axios from "axios";
import { api_host } from "../utils/settings";
import { createCheckoutSession } from "../utils/paymentApi";

const FINALIZED_KEY = "finalizedForSession";

export const Thanks = () => {
  const navigate = useNavigate();
  const { idSession, setIdSession } = React.useContext(IdSessionContext);
  const [error, setError] = useState<string | null>(null);
  const [isFinalizing, setIsFinalizing] = useState<boolean>(false);
  const [hasTriedFinalize, setHasTriedFinalize] = useState(false);

  const clearSession = () => {
    setIdSession(null);
    localStorage.removeItem("idSession");
    console.log('session C:EARED')
    // do NOT clear FINALIZED_KEY here; that is done when starting a new flow
  };

  useEffect(() => {
    const finalizeOrder = async () => {
      if (isFinalizing || hasTriedFinalize) return;

      // if we already finalized any session for this thanks-flow, never finalize again
      const alreadyFinalized = localStorage.getItem(FINALIZED_KEY);

      console.log('finalizing but yesa?', localStorage.getItem(FINALIZED_KEY))

      if (alreadyFinalized) {
        setHasTriedFinalize(true);
        return;
      }

      if (!idSession) return;

      const sessionId =
        typeof idSession === "string" ? idSession : (idSession as any)?.id;

      if (!sessionId) {
        setError("Missing session id, please start a new upload.");
        setHasTriedFinalize(true);
        return;
      }

      setIsFinalizing(true);
      try {
        await axios.get(`${api_host}/${sessionId}/finalize_order`);

        // mark that this thanks page has finalized once
        localStorage.setItem(FINALIZED_KEY, "true");

        clearSession();
        console.log("session cleared after finalize");
      } catch (e: any) {
        console.error("Finalize order failed", e);

        // If payment is required, redirect to Stripe checkout
        if (e.response?.status === 402) {
          try {
            const { session_url } = await createCheckoutSession(sessionId);
            window.location.href = session_url;
            return;
          } catch (paymentError) {
            console.error("Failed to create checkout session", paymentError);
            setError("Payment is required but could not be initiated. Please try again.");
          }
        } else {
          setError(
            "There was a problem finalizing your order. Please try again."
          );
        }
      } finally {
        setIsFinalizing(false);
        setHasTriedFinalize(true);
      }
    };

    finalizeOrder();
  }, [idSession, isFinalizing, hasTriedFinalize, setIdSession]);

  const handleUploadAnother = () => {
    // when starting a new flow, clear the finalized flag
    localStorage.removeItem(FINALIZED_KEY);
    navigate("/");
  };

  if (error) {
    return (
      <div className="flex flex-col ">
        <div className="flex-grow flex flex-col items-center justify-center px-6">
          <h2 className="thank-you">Something went wrong</h2>
          <p className="text-red-500 text-center mt-4">{error}</p>
          <button
            className="home-link text-primary mt-6 underline"
            onClick={handleUploadAnother}
          >
            Try again / upload another photo
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="flex flex-col ">
      <div className="flex-grow flex flex-col items-center justify-center px-6">
        <h2 className="thank-you">
          Thank you
          <br /> your ID-photo is uploaded!
        </h2>

        <a href="/" className="home-link text-primary" onClick={handleUploadAnother}>
          {isFinalizing ? "Finalizing order..." : "Upload another photo"}
        </a>
      </div>
    </div>
  );
};
